import type { CompletionSchema } from "./types";

// Generated by packages/completions/scripts/generate-default-schema.mjs from extension/assets/schema/pretext-dev.rng.
// Do not edit manually.
export const defaultDevSchema: CompletionSchema = {
  elementChildren: {
  "abbr": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "abstract": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "acknowledgement": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "acro": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "activity": {
    "elements": [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    "attributes": [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "ad": {
    "elements": [],
    "attributes": []
  },
  "address": {
    "elements": [],
    "attributes": []
  },
  "affiliation": {
    "elements": [
      "department",
      "institution",
      "location"
    ],
    "attributes": []
  },
  "alert": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "algorithm": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "alteration": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "flat",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "am": {
    "elements": [],
    "attributes": []
  },
  "angles": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "answer": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "appendix": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "notation-list",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "archive": {
    "elements": [],
    "attributes": [
      "from"
    ]
  },
  "area": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "correct"
    ]
  },
  "areas": {
    "elements": [
      "p"
    ],
    "attributes": []
  },
  "argument": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "article": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "backmatter",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "frontmatter",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subtitle",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "articletitle": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "aside": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "assemblage": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "assumption": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "asymptote": {
    "elements": [],
    "attributes": [
      "component",
      "label"
    ]
  },
  "asymptote-preamble": {
    "elements": [],
    "attributes": []
  },
  "attr": {
    "elements": [],
    "attributes": []
  },
  "attribution": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "author": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "affiliation",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "biography",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "department",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "institution",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "location",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "personname",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "support",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "corresponding",
      "halign",
      "xml:id"
    ]
  },
  "author-biographies": {
    "elements": [],
    "attributes": [
      "length"
    ]
  },
  "axiom": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "backmatter": {
    "elements": [
      "appendix",
      "colophon",
      "idx",
      "index",
      "references",
      "solutions",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "bc": {
    "elements": [],
    "attributes": []
  },
  "bibinfo": {
    "elements": [
      "author",
      "copyright",
      "credit",
      "date",
      "edition",
      "editor",
      "keywords",
      "support",
      "website"
    ],
    "attributes": []
  },
  "biblio": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "author",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "editor",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "ibid",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "journal",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "note",
      "number",
      "obelus",
      "pages",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "publisher",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "series",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "title",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "volume",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref",
      "year"
    ],
    "attributes": [
      "component",
      "label",
      "type",
      "xml:id"
    ]
  },
  "biographical": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "biography": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "block": {
    "elements": [
      "blockquote",
      "choice",
      "cline",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": [
      "correct",
      "order"
    ]
  },
  "blockquote": {
    "elements": [
      "attribution",
      "idx",
      "p",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "blocks": {
    "elements": [
      "block"
    ],
    "attributes": [
      "layout",
      "randomize"
    ]
  },
  "blurb": {
    "elements": [],
    "attributes": [
      "shelf"
    ]
  },
  "book": {
    "elements": [
      "backmatter",
      "chapter",
      "frontmatter",
      "handout",
      "idx",
      "part",
      "plaintitle",
      "shorttitle",
      "subtitle",
      "title",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "brandlogo": {
    "elements": [],
    "attributes": [
      "source",
      "url"
    ]
  },
  "c": {
    "elements": [],
    "attributes": []
  },
  "ca": {
    "elements": [],
    "attributes": []
  },
  "caption": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "case": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "direction",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "cd": {
    "elements": [
      "cline"
    ],
    "attributes": [
      "latexsep"
    ]
  },
  "cell": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "bottom",
      "colspan",
      "halign",
      "right"
    ]
  },
  "chapter": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "checkpoint": {
    "elements": [
      "feedback",
      "prompt"
    ],
    "attributes": [
      "answer",
      "answer-variable",
      "line"
    ]
  },
  "choice": {
    "elements": [
      "blockquote",
      "cline",
      "console",
      "feedback",
      "image",
      "p",
      "pre",
      "program",
      "statement",
      "tabular",
      "video"
    ],
    "attributes": [
      "correct"
    ]
  },
  "choices": {
    "elements": [
      "choice"
    ],
    "attributes": [
      "randomize"
    ]
  },
  "chord": {
    "elements": [
      "alteration"
    ],
    "attributes": [
      "bass",
      "bps",
      "mode",
      "parentheses",
      "root",
      "suspended"
    ]
  },
  "claim": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "cline": {
    "elements": [],
    "attributes": []
  },
  "code": {
    "elements": [],
    "attributes": []
  },
  "col": {
    "elements": [],
    "attributes": [
      "halign",
      "right",
      "top",
      "width"
    ]
  },
  "colophon": {
    "elements": [
      "blockquote",
      "colophon-items",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "colophon-items": {
    "elements": [],
    "attributes": []
  },
  "computation": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "conclusion": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "conjecture": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "console": {
    "elements": [
      "input",
      "output"
    ],
    "attributes": [
      "component",
      "continuation",
      "margins",
      "prompt",
      "width"
    ]
  },
  "contributor": {
    "elements": [
      "affiliation",
      "department",
      "email",
      "idx",
      "institution",
      "location",
      "personname"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "contributors": {
    "elements": [
      "contributor"
    ],
    "attributes": []
  },
  "convention": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "copyleft": {
    "elements": [],
    "attributes": []
  },
  "copyright": {
    "elements": [
      "holder",
      "minilicense",
      "shortlicense",
      "year"
    ],
    "attributes": []
  },
  "corollary": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "creator": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "credit": {
    "elements": [
      "author",
      "entity",
      "role",
      "title"
    ],
    "attributes": []
  },
  "cross-references": {
    "elements": [],
    "attributes": [
      "text"
    ]
  },
  "data": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "date": {
    "elements": [
      "ad",
      "am",
      "bc",
      "ca",
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "eg",
      "ellipsis",
      "etal",
      "etc",
      "fillin",
      "icon",
      "ie",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "tex",
      "timeofday",
      "times",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "dblbrackets": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "dblprime": {
    "elements": [],
    "attributes": []
  },
  "dedication": {
    "elements": [
      "idx",
      "p",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "definition": {
    "elements": [
      "idx",
      "notation",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "degree": {
    "elements": [],
    "attributes": []
  },
  "delete": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "department": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "description": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tabular",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "division": {
    "elements": [],
    "attributes": [
      "part"
    ]
  },
  "dl": {
    "elements": [
      "li"
    ],
    "attributes": [
      "component",
      "width"
    ]
  },
  "docinfo": {
    "elements": [
      "asymptote-preamble",
      "author-biographies",
      "blurb",
      "brandlogo",
      "cross-references",
      "document-id",
      "feedback",
      "images",
      "initialism",
      "latex-image-preamble",
      "macros",
      "math-package",
      "numbering",
      "parsons",
      "programs",
      "rename"
    ],
    "attributes": [
      "xml:base",
      "xml:lang"
    ]
  },
  "document-id": {
    "elements": [],
    "attributes": [
      "edition"
    ]
  },
  "doubleflat": {
    "elements": [],
    "attributes": []
  },
  "doublesharp": {
    "elements": [],
    "attributes": []
  },
  "edition": {
    "elements": [],
    "attributes": []
  },
  "editor": {
    "elements": [
      "affiliation",
      "department",
      "email",
      "institution",
      "location",
      "personname"
    ],
    "attributes": []
  },
  "eg": {
    "elements": [],
    "attributes": []
  },
  "ellipsis": {
    "elements": [],
    "attributes": []
  },
  "em": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "email": {
    "elements": [],
    "attributes": []
  },
  "entity": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "etal": {
    "elements": [],
    "attributes": []
  },
  "etc": {
    "elements": [],
    "attributes": []
  },
  "event": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "example": {
    "elements": [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "exercise": {
    "elements": [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "pre",
      "preamble",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    "attributes": [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "workspace",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "exercisegroup": {
    "elements": [
      "conclusion",
      "exercise",
      "idx",
      "introduction",
      "title"
    ],
    "attributes": [
      "cols",
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "exercises": {
    "elements": [
      "conclusion",
      "exercise",
      "exercisegroup",
      "idx",
      "interactive",
      "introduction",
      "plaintitle",
      "shorttitle",
      "subexercises",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "explanation": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "exploration": {
    "elements": [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    "attributes": [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "fact": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "feedback": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "url",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "figure": {
    "elements": [
      "caption",
      "idx",
      "image",
      "interactive",
      "sbsgroup",
      "score",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "fillin": {
    "elements": [],
    "attributes": [
      "characters",
      "cols",
      "fill",
      "rows"
    ]
  },
  "flat": {
    "elements": [],
    "attributes": []
  },
  "fn": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "foreign": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "xml:lang"
    ]
  },
  "fragment": {
    "elements": [
      "code",
      "fragref",
      "title"
    ],
    "attributes": [
      "filename",
      "xml:id"
    ]
  },
  "fragref": {
    "elements": [],
    "attributes": [
      "ref"
    ]
  },
  "frontmatter": {
    "elements": [
      "abstract",
      "acknowledgement",
      "bibinfo",
      "biography",
      "colophon",
      "dedication",
      "idx",
      "preface",
      "title",
      "titlepage"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "genus": {
    "elements": [],
    "attributes": []
  },
  "gi": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "glossary": {
    "elements": [
      "gi",
      "headnote",
      "idx",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "h": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": [
      "sortby"
    ]
  },
  "handout": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "page",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    "attributes": [
      "bottom",
      "component",
      "label",
      "left",
      "margin",
      "right",
      "top",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "headnote": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "heuristic": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "hint": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "historical": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "holder": {
    "elements": [],
    "attributes": []
  },
  "hypothesis": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "ibid": {
    "elements": [],
    "attributes": []
  },
  "icon": {
    "elements": [],
    "attributes": [
      "name"
    ]
  },
  "identity": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "idx": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "h",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "see",
      "seealso",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": [
      "component",
      "finish",
      "label",
      "sortby",
      "start",
      "xml:id"
    ]
  },
  "ie": {
    "elements": [],
    "attributes": []
  },
  "image": {
    "elements": [
      "asymptote",
      "description",
      "latex-image",
      "sageplot",
      "shortdescription"
    ],
    "attributes": [
      "archive",
      "component",
      "decorative",
      "margins",
      "pg-name",
      "rotate",
      "source",
      "width",
      "xml:id"
    ]
  },
  "images": {
    "elements": [
      "archive"
    ],
    "attributes": []
  },
  "index": {
    "elements": [
      "idx",
      "index-list",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "index-list": {
    "elements": [],
    "attributes": []
  },
  "init": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "initialism": {
    "elements": [],
    "attributes": []
  },
  "input": {
    "elements": [],
    "attributes": [
      "continuation",
      "onclick",
      "onkeypress",
      "prompt",
      "style",
      "type",
      "value"
    ]
  },
  "insert": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "insight": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "institution": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "instruction": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "instructions": {
    "elements": [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "interactive": {
    "elements": [
      "instructions",
      "sbsgroup",
      "sidebyside",
      "slate",
      "static"
    ],
    "attributes": [
      "aspect",
      "component",
      "iframe",
      "label",
      "platform",
      "preview",
      "source",
      "version",
      "width",
      "xml:id"
    ]
  },
  "interlude": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "intertext": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "introduction": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "investigation": {
    "elements": [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    "attributes": [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "iotest": {
    "elements": [
      "input",
      "output"
    ],
    "attributes": []
  },
  "journal": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "justification": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "kbd": {
    "elements": [],
    "attributes": [
      "name"
    ]
  },
  "keyword": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": [
      "primary"
    ]
  },
  "keywords": {
    "elements": [
      "keyword",
      "title"
    ],
    "attributes": [
      "authority",
      "variant"
    ]
  },
  "langle": {
    "elements": [],
    "attributes": []
  },
  "latex": {
    "elements": [],
    "attributes": []
  },
  "latex-image": {
    "elements": [],
    "attributes": [
      "component",
      "label"
    ]
  },
  "latex-image-preamble": {
    "elements": [],
    "attributes": []
  },
  "ldblbracket": {
    "elements": [],
    "attributes": []
  },
  "lemma": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "letter": {
    "elements": [],
    "attributes": []
  },
  "li": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "aside",
      "attr",
      "bc",
      "biographical",
      "blockquote",
      "c",
      "ca",
      "cd",
      "chord",
      "console",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "figure",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "historical",
      "icon",
      "idx",
      "ie",
      "image",
      "init",
      "insert",
      "interactive",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "list",
      "listing",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "pre",
      "prefigure",
      "pretext",
      "prime",
      "program",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "sage",
      "sbsgroup",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "sidebyside",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "table",
      "tabular",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "title",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "video",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "line": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "indent"
    ]
  },
  "list": {
    "elements": [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "plaintitle",
      "shorttitle",
      "title",
      "ul"
    ],
    "attributes": [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "list-of": {
    "elements": [],
    "attributes": [
      "divisions",
      "elements",
      "empty",
      "scope"
    ]
  },
  "listing": {
    "elements": [
      "console",
      "idx",
      "plaintitle",
      "program",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "location": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "lq": {
    "elements": [],
    "attributes": []
  },
  "lsq": {
    "elements": [],
    "attributes": []
  },
  "m": {
    "elements": [
      "fillin",
      "var"
    ],
    "attributes": []
  },
  "macro-file": {
    "elements": [],
    "attributes": []
  },
  "macros": {
    "elements": [],
    "attributes": []
  },
  "mag": {
    "elements": [],
    "attributes": []
  },
  "match": {
    "elements": [
      "premise",
      "response"
    ],
    "attributes": [
      "order"
    ]
  },
  "matches": {
    "elements": [
      "match"
    ],
    "attributes": []
  },
  "math-package": {
    "elements": [],
    "attributes": [
      "latex-name",
      "mathjax-name"
    ]
  },
  "md": {
    "elements": [
      "fillin",
      "intertext",
      "mrow",
      "var",
      "xref"
    ],
    "attributes": [
      "alignat-columns",
      "alignment",
      "break",
      "number"
    ]
  },
  "mdash": {
    "elements": [],
    "attributes": []
  },
  "mdn": {
    "elements": [
      "fillin",
      "intertext",
      "mrow",
      "var"
    ],
    "attributes": [
      "alignat-columns",
      "alignment",
      "break",
      "number"
    ]
  },
  "me": {
    "elements": [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "memo": {
    "elements": [],
    "attributes": []
  },
  "men": {
    "elements": [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "midpoint": {
    "elements": [],
    "attributes": []
  },
  "minilicense": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "minus": {
    "elements": [],
    "attributes": []
  },
  "mrow": {
    "elements": [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    "attributes": [
      "break",
      "component",
      "label",
      "number",
      "tag",
      "xml:id"
    ]
  },
  "myopenmath": {
    "elements": [],
    "attributes": [
      "params",
      "problem"
    ]
  },
  "n": {
    "elements": [],
    "attributes": [
      "acc",
      "octave",
      "pc"
    ]
  },
  "name": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "natural": {
    "elements": [],
    "attributes": []
  },
  "nb": {
    "elements": [],
    "attributes": []
  },
  "nbsp": {
    "elements": [],
    "attributes": []
  },
  "ndash": {
    "elements": [],
    "attributes": []
  },
  "notation": {
    "elements": [
      "description",
      "usage"
    ],
    "attributes": []
  },
  "notation-list": {
    "elements": [],
    "attributes": []
  },
  "note": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "number": {
    "elements": [],
    "attributes": []
  },
  "numbering": {
    "elements": [
      "division"
    ],
    "attributes": []
  },
  "obelus": {
    "elements": [],
    "attributes": []
  },
  "objectives": {
    "elements": [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "title",
      "ul"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "observation": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "ol": {
    "elements": [
      "li"
    ],
    "attributes": [
      "cols",
      "component",
      "marker"
    ]
  },
  "outcomes": {
    "elements": [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "title",
      "ul"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "output": {
    "elements": [],
    "attributes": []
  },
  "p": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "cd",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": [
      "component",
      "label",
      "xml:id"
    ]
  },
  "page": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "video",
      "warning"
    ],
    "attributes": []
  },
  "pages": {
    "elements": [],
    "attributes": [
      "end",
      "start"
    ]
  },
  "paragraphs": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "parsons": {
    "elements": [],
    "attributes": [
      "language"
    ]
  },
  "part": {
    "elements": [
      "chapter",
      "idx",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "per": {
    "elements": [],
    "attributes": [
      "base",
      "exp",
      "prefix"
    ]
  },
  "permille": {
    "elements": [],
    "attributes": []
  },
  "personname": {
    "elements": [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    "attributes": []
  },
  "pf": {
    "elements": [],
    "attributes": [
      "language"
    ]
  },
  "pg-code": {
    "elements": [],
    "attributes": []
  },
  "pg-macros": {
    "elements": [
      "macro-file"
    ],
    "attributes": []
  },
  "phonomark": {
    "elements": [],
    "attributes": []
  },
  "pilcrow": {
    "elements": [],
    "attributes": []
  },
  "plaintitle": {
    "elements": [],
    "attributes": []
  },
  "plusminus": {
    "elements": [],
    "attributes": []
  },
  "pm": {
    "elements": [],
    "attributes": []
  },
  "poem": {
    "elements": [
      "author",
      "idx",
      "line",
      "stanza",
      "title"
    ],
    "attributes": [
      "component",
      "halign",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "postamble": {
    "elements": [],
    "attributes": [
      "indent",
      "visible"
    ]
  },
  "postlude": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "pre": {
    "elements": [
      "cline"
    ],
    "attributes": []
  },
  "preamble": {
    "elements": [],
    "attributes": [
      "indent",
      "visible"
    ]
  },
  "preface": {
    "elements": [
      "aside",
      "attribution",
      "biographical",
      "blockquote",
      "console",
      "contributors",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "prefigure": {
    "elements": [],
    "attributes": []
  },
  "prelude": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "premise": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "pretext": {
    "elements": [
      "article",
      "book",
      "docinfo",
      "letter",
      "memo"
    ],
    "attributes": [
      "xml:lang"
    ]
  },
  "prime": {
    "elements": [],
    "attributes": []
  },
  "principle": {
    "elements": [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "problem": {
    "elements": [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "program": {
    "elements": [
      "checkpoint",
      "code",
      "postamble",
      "preamble",
      "stdin",
      "tests"
    ],
    "attributes": [
      "add-files",
      "autorun",
      "chatcodes",
      "codelens",
      "compile-also",
      "compiler-args",
      "component",
      "database",
      "download",
      "extra-compiler-args",
      "filename",
      "hidecode",
      "highlight-lines",
      "include",
      "interactive",
      "interpreter-args",
      "label",
      "language",
      "line-numbers",
      "linker-args",
      "margins",
      "starting-step",
      "timelimit",
      "width",
      "xml:id"
    ]
  },
  "programs": {
    "elements": [],
    "attributes": [
      "compiler-args",
      "download",
      "interpreter-args",
      "language",
      "linenumbers",
      "linker-args",
      "timeout"
    ]
  },
  "project": {
    "elements": [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    "attributes": [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "prompt": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "proof": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "proposition": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "ps": {
    "elements": [],
    "attributes": []
  },
  "publisher": {
    "elements": [],
    "attributes": []
  },
  "pubtitle": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "q": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "quantity": {
    "elements": [
      "mag",
      "per",
      "unit"
    ],
    "attributes": []
  },
  "question": {
    "elements": [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "rangle": {
    "elements": [],
    "attributes": []
  },
  "rdblbracket": {
    "elements": [],
    "attributes": []
  },
  "reading-questions": {
    "elements": [
      "conclusion",
      "exercise",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "reasoning": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "references": {
    "elements": [
      "biblio",
      "conclusion",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "registered": {
    "elements": [],
    "attributes": []
  },
  "remark": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "rename": {
    "elements": [],
    "attributes": [
      "element",
      "xml:lang"
    ]
  },
  "response": {
    "elements": [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    "attributes": []
  },
  "role": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "row": {
    "elements": [
      "cell"
    ],
    "attributes": [
      "bottom",
      "halign",
      "header",
      "left",
      "valign"
    ]
  },
  "rq": {
    "elements": [],
    "attributes": []
  },
  "rsq": {
    "elements": [],
    "attributes": []
  },
  "sage": {
    "elements": [
      "input",
      "output"
    ],
    "attributes": [
      "auto-evaluate",
      "component",
      "doctest",
      "language",
      "tolerance",
      "type"
    ]
  },
  "sageplot": {
    "elements": [],
    "attributes": [
      "aspect",
      "component",
      "label",
      "variant"
    ]
  },
  "sbsgroup": {
    "elements": [
      "sidebyside"
    ],
    "attributes": [
      "component",
      "margins",
      "valign",
      "valigns",
      "width",
      "widths"
    ]
  },
  "scaledeg": {
    "elements": [],
    "attributes": []
  },
  "score": {
    "elements": [],
    "attributes": [
      "musescore",
      "musescoreuser"
    ]
  },
  "section": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "section-mark": {
    "elements": [],
    "attributes": []
  },
  "see": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "seealso": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "series": {
    "elements": [],
    "attributes": []
  },
  "servicemark": {
    "elements": [],
    "attributes": []
  },
  "sharp": {
    "elements": [],
    "attributes": []
  },
  "shortdescription": {
    "elements": [
      "var"
    ],
    "attributes": []
  },
  "shortlicense": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "shorttitle": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  },
  "sidebyside": {
    "elements": [
      "console",
      "dl",
      "exercise",
      "figure",
      "image",
      "interactive",
      "list",
      "listing",
      "ol",
      "p",
      "poem",
      "pre",
      "program",
      "slate",
      "stack",
      "table",
      "tabular",
      "task",
      "ul",
      "video"
    ],
    "attributes": [
      "component",
      "margins",
      "valign",
      "valigns",
      "width",
      "widths"
    ]
  },
  "slate": {
    "elements": [
      "input",
      "p",
      "sidebyside",
      "tabular",
      "xhtml:button"
    ],
    "attributes": [
      "aspect",
      "axis",
      "component",
      "grid",
      "label",
      "material",
      "source",
      "surface",
      "xml:id"
    ]
  },
  "solidus": {
    "elements": [],
    "attributes": []
  },
  "solution": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "solutions": {
    "elements": [
      "conclusion",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "admit",
      "component",
      "divisional",
      "inline",
      "label",
      "project",
      "reading",
      "scope",
      "worksheet",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "species": {
    "elements": [],
    "attributes": []
  },
  "sq": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "stack": {
    "elements": [
      "console",
      "dl",
      "image",
      "ol",
      "p",
      "pre",
      "program",
      "slate",
      "tabular",
      "ul",
      "video"
    ],
    "attributes": []
  },
  "stale": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "stanza": {
    "elements": [
      "idx",
      "line",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "statement": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "image",
      "instruction",
      "interactive",
      "list",
      "listing",
      "ol",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "video"
    ],
    "attributes": [
      "correct"
    ]
  },
  "static": {
    "elements": [
      "image"
    ],
    "attributes": []
  },
  "stdin": {
    "elements": [],
    "attributes": []
  },
  "subexercises": {
    "elements": [
      "conclusion",
      "exercise",
      "exercisegroup",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "subsection": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsubsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "subsubsection": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "subtitle": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "support": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "cd",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "swungdash": {
    "elements": [],
    "attributes": []
  },
  "table": {
    "elements": [
      "idx",
      "plaintitle",
      "shorttitle",
      "tabular",
      "title"
    ],
    "attributes": [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "tabular": {
    "elements": [
      "col",
      "row"
    ],
    "attributes": [
      "bottom",
      "component",
      "halign",
      "left",
      "margins",
      "right",
      "row-headers",
      "top",
      "valign",
      "width"
    ]
  },
  "tag": {
    "elements": [],
    "attributes": []
  },
  "tage": {
    "elements": [],
    "attributes": []
  },
  "task": {
    "elements": [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "workspace",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "taxon": {
    "elements": [
      "genus",
      "species"
    ],
    "attributes": [
      "ncbi"
    ]
  },
  "technology": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "term": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "tests": {
    "elements": [
      "iotest"
    ],
    "attributes": [
      "visible"
    ]
  },
  "tex": {
    "elements": [],
    "attributes": []
  },
  "theorem": {
    "elements": [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "timeofday": {
    "elements": [],
    "attributes": []
  },
  "times": {
    "elements": [],
    "attributes": []
  },
  "timesignature": {
    "elements": [],
    "attributes": [
      "bottom",
      "top"
    ]
  },
  "title": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    "attributes": []
  },
  "titlepage": {
    "elements": [
      "titlepage-items"
    ],
    "attributes": []
  },
  "titlepage-items": {
    "elements": [],
    "attributes": []
  },
  "today": {
    "elements": [],
    "attributes": []
  },
  "trademark": {
    "elements": [],
    "attributes": []
  },
  "ul": {
    "elements": [
      "li"
    ],
    "attributes": [
      "cols",
      "component",
      "marker"
    ]
  },
  "unit": {
    "elements": [],
    "attributes": [
      "base",
      "exp",
      "prefix"
    ]
  },
  "url": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": [
      "href",
      "visual"
    ]
  },
  "usage": {
    "elements": [
      "m"
    ],
    "attributes": []
  },
  "var": {
    "elements": [],
    "attributes": [
      "category",
      "evaluator",
      "form",
      "name",
      "width"
    ]
  },
  "video": {
    "elements": [],
    "attributes": [
      "aspect",
      "component",
      "end",
      "href",
      "label",
      "margins",
      "play-at",
      "preview",
      "source",
      "start",
      "vimeo",
      "width",
      "xml:id",
      "youtube",
      "youtubeplaylist"
    ]
  },
  "viz": {
    "elements": [],
    "attributes": []
  },
  "volume": {
    "elements": [],
    "attributes": []
  },
  "vs": {
    "elements": [],
    "attributes": []
  },
  "warning": {
    "elements": [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    "attributes": [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "website": {
    "elements": [
      "address",
      "name",
      "url"
    ],
    "attributes": []
  },
  "webwork": {
    "elements": [
      "conclusion",
      "description",
      "hint",
      "introduction",
      "pg-code",
      "pg-macros",
      "solution",
      "statement",
      "task"
    ],
    "attributes": [
      "component",
      "copy",
      "label",
      "seed",
      "source",
      "xml:id"
    ]
  },
  "worksheet": {
    "elements": [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "page",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    "attributes": [
      "bottom",
      "component",
      "label",
      "left",
      "margin",
      "right",
      "top",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "xelatex": {
    "elements": [],
    "attributes": []
  },
  "xetex": {
    "elements": [],
    "attributes": []
  },
  "xhtml:button": {
    "elements": [],
    "attributes": [
      "id",
      "type"
    ]
  },
  "xref": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": [
      "detail",
      "first",
      "last",
      "provisional",
      "ref",
      "text"
    ]
  },
  "year": {
    "elements": [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    "attributes": []
  }
}
};
